import { QueryClient, UndefinedInitialDataOptions, UseQueryResult, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useGlobalContext } from '../GlobalContextProvider';

export function useQueryWithAuth<TQueryFnData = unknown, TData = TQueryFnData>(
    {
      queryKey,
      ...options
    }: UndefinedInitialDataOptions<TQueryFnData, AxiosError, TData, any[]> & { silent404?: boolean },
    queryClient?: QueryClient,
  ): UseQueryResult<TData, AxiosError> {
    const { authTokens } = useGlobalContext();
    const opts = {
      queryKey: [...queryKey],
      enabled: !!options.enabled ? options.enabled && !!authTokens : !!authTokens,
      ...options,
    };
    return useQuery(opts, queryClient);
  }